import { Input, Modal, Tabs } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import GeneralModal from "../General.modal";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";

const UpdateDepartment = ({ updateParent, data }) => {
  const { t } = useTranslation("dashboard");
  const [formData, setFormData] = useState({
    title: "",
    address: ""
  });

  const { Title } = Typography;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChange = (key, val) => {
    setFormData({
      ...formData,
      [key]: val
    });
  };

  const onSubmit = async e => {
    await axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/departments/update/${data?._id}`, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    setFormData({
      title: data?.title,
      address: data?.address
    });

    return () => {};
  }, [data]);

  const onChangetab = key => {};
  const items = (
    <>
      <div className="row form-row">
        <div className="col-12 col-sm-12">
          <div className="form-group">
            <Title level={5} className="modals-inputs-label">
              {t("Title")}
            </Title>
            <Input
              value={formData.title}
              onChange={e => handleChange("title", e.target.value)}
              type="text"
              className="w-100"
            />
          </div>
        </div>
        <div className="col-12 col-sm-12">
          <div className="form-group">
            <Title level={5} className="modals-inputs-label">
              {t("Address")}
            </Title>
            <Input
              value={formData.address}
              onChange={e => handleChange("address", e.target.value)}
              type="text"
              className="w-100"
            />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className="UpdateDepartment">
      <MainButtonComp text="Edit" editBtn onClick={showModal} />
      <GeneralModal
        title={t("Update Department")}
        onOk={() => onSubmit(formData)}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={onChangetab}
        items={items}
      />
    </div>
  );
};

export default UpdateDepartment;
